import { render, staticRenderFns } from "./PresentInDatabaseHeader.vue?vue&type=template&id=94d085ce&scoped=true&"
import script from "./PresentInDatabaseHeader.vue?vue&type=script&lang=js&"
export * from "./PresentInDatabaseHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d085ce",
  null
  
)

/* custom blocks */
import block0 from "./PresentInDatabaseHeader.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports